module.exports = __webpack_public_path__ + "assets/img/block-left-hover-04e8965f.png";